<section class="pd-tb empChoice">
    <div class="container">
        <div>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"> <a routerLink="/dashboard-job">Home</a></li>
                <li class="breadcrumb-item active"> <a routerLink="/employer-choice">Employers of choice</a></li>
            </ol>
        </div>
        <h3 class="subheading flexcss">Employers of choice</h3>
        <div class="row">
            <div *ngFor="let employer of employersList;" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12"
                [routerLink]="'details/' + employer?.id+'/about'">
                <div class="card-grid-2">
                    <div class="card-grid-2-image-left">
                        <div class="image-box"> 
                            <img src="{{employer.profileImage != null  || employer?.recruiter?.profileImage ? recruiterImagePath : ''}}{{employer.profileImage != null  || employer?.recruiter?.profileImage ? employer.profileImage || employer?.recruiter?.profileImage  : 'assets/images/profile-img.jpg' }}" alt="jobBox">
                        </div>
                        <div class="right-info">
                            <p class="name-job">{{employer.companyName || employer?.recruiter?.companyName}}</p>
                            <span class="location-small">{{employer.location || employer?.recruiter?.location}}</span>
                            <p class="para12">{{employer.matchingJobsCount}} jobs matching your profile</p>
                        </div>
                        <div class="arrow"><a><img src="assets/images/ic_arrow_next.svg"></a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 p-0" *ngIf="employersList?.listing > 0">
            <ul class="pagination ">
                <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;" nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls> 
            </ul>
        </div>
    </div>
</section>